// extracted by mini-css-extract-plugin
module.exports = {"container":"_3JJ0-z mz-default-dark-font","details":"_23O_8Y"};